export default __webpack_public_path__ + "static/media/nav-settings-outline.766e45e7.svg";